<template>
  <BaseCard
    title="datos del proveedor"
    :loading="loading"
    @save-button-click="handleSaveButtonClick"
  >
    <ProviderProfileForm
      ref="provider-profile-form"
      v-model="provider"
      :number-visible="true"
    />
    <hr class="mx-2">
    <b-card-title class="m-0 py-1 px-2">
      <b-row align-v="center">
        <b-col
          class="font-weight-bold d-flex align-items-center"
          cols="auto"
        >
          INFORMACIÓN BANCARIA Y DE PAGO
        </b-col>
      </b-row>
    </b-card-title>
    <ProviderBillingForm
      ref="provider-billing-form"
      v-model="provider"
    />
  </BaseCard>
</template>

<script>
import ApiRestService from '@/api/base-api'
import ProviderProfileForm from '@/components/providers/form/ProviderProfileForm.vue'
import ProviderBillingForm from '@/components/providers/form/ProviderBillingForm.vue'
import BaseCard from '@/components/ui/card/BaseCard.vue'

export default {
  components: {
    BaseCard,
    ProviderBillingForm,
    ProviderProfileForm,
  },
  data() {
    return {
      loading: false,
      provider: {},
    }
  },
  computed: {
    providerProfileForm() {
      return this.$refs['provider-profile-form']
    },
    providerBillingForm() {
      return this.$refs['provider-billing-form']
    },
  },
  mounted() {
    this.loadProvider()
  },
  methods: {
    async loadProvider() {
      try {
        this.loading = true
        const response = await ApiRestService.get(this.$route.params.id, this.$data.$constants.RESOURCES.RESOURCE_PROVIDERS)
        this.provider = response.data
      } finally {
        this.loading = false
      }
    },
    async handleSaveButtonClick() {
      const formsValidation = await Promise.all([
        this.providerProfileForm.validateForm(),
        this.providerBillingForm.validateForm(),
      ])

      if (formsValidation.some(valid => !valid)) {
        return
      }

      this.loading = true
      try {
        if (this.providerProfileForm.isImageRemoved()) {
          await ApiRestService.deleteImage(this.$route.params.id, this.$data.$constants.RESOURCES.RESOURCE_PROVIDERS)
        }

        await ApiRestService.edit(this.$route.params.id, this.provider, this.$data.$constants.RESOURCES.RESOURCE_PROVIDERS)
        await this.$router.go(-1)
      } catch (error) {
        if (error.response.data?.error) {
          this.$toast.error(error.response.data.error)
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
</style>
